// components/X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var X = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("title", { children: "X" }),
        /* @__PURE__ */ jsx("path", { d: "M18 6 6 18" }),
        /* @__PURE__ */ jsx("path", { d: "m6 6 12 12" })
      ]
    }
  );
};

// components/Users.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Users = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs2(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx2("title", { children: "Users" }),
        /* @__PURE__ */ jsx2("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
        /* @__PURE__ */ jsx2("circle", { cx: "9", cy: "7", r: "4" }),
        /* @__PURE__ */ jsx2("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
        /* @__PURE__ */ jsx2("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
      ]
    }
  );
};

// components/User.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var User = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs3(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx3("title", { children: "User" }),
        /* @__PURE__ */ jsx3("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
        /* @__PURE__ */ jsx3("circle", { cx: "12", cy: "7", r: "4" })
      ]
    }
  );
};

// components/UserSearch.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var UserSearch = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs4(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx4("title", { children: "UserSearch" }),
        /* @__PURE__ */ jsx4("circle", { cx: "10", cy: "7", r: "4" }),
        /* @__PURE__ */ jsx4("path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2" }),
        /* @__PURE__ */ jsx4("circle", { cx: "17", cy: "17", r: "3" }),
        /* @__PURE__ */ jsx4("path", { d: "m21 21-1.9-1.9" })
      ]
    }
  );
};

// components/UserRoundPlus.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var UserRoundPlus = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs5(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx5("title", { children: "UserRoundPlus" }),
        /* @__PURE__ */ jsx5("path", { d: "M2 21a8 8 0 0 1 13.292-6" }),
        /* @__PURE__ */ jsx5("circle", { cx: "10", cy: "8", r: "5" }),
        /* @__PURE__ */ jsx5("path", { d: "M19 16v6" }),
        /* @__PURE__ */ jsx5("path", { d: "M22 19h-6" })
      ]
    }
  );
};

// components/UserCog.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var UserCog = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs6(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx6("title", { children: "UserCog" }),
        /* @__PURE__ */ jsx6("circle", { cx: "18", cy: "15", r: "3" }),
        /* @__PURE__ */ jsx6("circle", { cx: "9", cy: "7", r: "4" }),
        /* @__PURE__ */ jsx6("path", { d: "M10 15H6a4 4 0 0 0-4 4v2" }),
        /* @__PURE__ */ jsx6("path", { d: "m21.7 16.4-.9-.3" }),
        /* @__PURE__ */ jsx6("path", { d: "m15.2 13.9-.9-.3" }),
        /* @__PURE__ */ jsx6("path", { d: "m16.6 18.7.3-.9" }),
        /* @__PURE__ */ jsx6("path", { d: "m19.1 12.2.3-.9" }),
        /* @__PURE__ */ jsx6("path", { d: "m19.6 18.7-.4-1" }),
        /* @__PURE__ */ jsx6("path", { d: "m16.8 12.3-.4-1" }),
        /* @__PURE__ */ jsx6("path", { d: "m14.3 16.6 1-.4" }),
        /* @__PURE__ */ jsx6("path", { d: "m20.7 13.8 1-.4" })
      ]
    }
  );
};

// components/TriangleAlert.tsx
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var TriangleAlert = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs7(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx7("title", { children: "TriangleAlert" }),
        /* @__PURE__ */ jsx7("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }),
        /* @__PURE__ */ jsx7("path", { d: "M12 9v4" }),
        /* @__PURE__ */ jsx7("path", { d: "M12 17h.01" })
      ]
    }
  );
};

// components/Trash.tsx
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var Trash = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs8(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx8("title", { children: "Trash" }),
        /* @__PURE__ */ jsx8("path", { d: "M3 6h18" }),
        /* @__PURE__ */ jsx8("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
        /* @__PURE__ */ jsx8("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" })
      ]
    }
  );
};

// components/Trash2.tsx
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var Trash2 = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs9(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx9("title", { children: "Trash2" }),
        /* @__PURE__ */ jsx9("path", { d: "M3 6h18" }),
        /* @__PURE__ */ jsx9("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
        /* @__PURE__ */ jsx9("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }),
        /* @__PURE__ */ jsx9("line", { x1: "10", x2: "10", y1: "11", y2: "17" }),
        /* @__PURE__ */ jsx9("line", { x1: "14", x2: "14", y1: "11", y2: "17" })
      ]
    }
  );
};

// components/ThumbsUp.tsx
import { jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var ThumbsUp = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs10(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx10("title", { children: "ThumbsUp" }),
        /* @__PURE__ */ jsx10("path", { d: "M7 10v12" }),
        /* @__PURE__ */ jsx10("path", { d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" })
      ]
    }
  );
};

// components/Tag.tsx
import { jsx as jsx11, jsxs as jsxs11 } from "react/jsx-runtime";
var Tag = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs11(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx11("title", { children: "Tag" }),
        /* @__PURE__ */ jsx11("path", { d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" }),
        /* @__PURE__ */ jsx11("circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" })
      ]
    }
  );
};

// components/Sun.tsx
import { jsx as jsx12, jsxs as jsxs12 } from "react/jsx-runtime";
var Sun = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs12(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx12("title", { children: "Sun" }),
        /* @__PURE__ */ jsx12("circle", { cx: "12", cy: "12", r: "4" }),
        /* @__PURE__ */ jsx12("path", { d: "M12 2v2" }),
        /* @__PURE__ */ jsx12("path", { d: "M12 20v2" }),
        /* @__PURE__ */ jsx12("path", { d: "m4.93 4.93 1.41 1.41" }),
        /* @__PURE__ */ jsx12("path", { d: "m17.66 17.66 1.41 1.41" }),
        /* @__PURE__ */ jsx12("path", { d: "M2 12h2" }),
        /* @__PURE__ */ jsx12("path", { d: "M20 12h2" }),
        /* @__PURE__ */ jsx12("path", { d: "m6.34 17.66-1.41 1.41" }),
        /* @__PURE__ */ jsx12("path", { d: "m19.07 4.93-1.41 1.41" })
      ]
    }
  );
};

// components/SquarePen.tsx
import { jsx as jsx13, jsxs as jsxs13 } from "react/jsx-runtime";
var SquarePen = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs13(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx13("title", { children: "SquarePen" }),
        /* @__PURE__ */ jsx13("path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
        /* @__PURE__ */ jsx13("path", { d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" })
      ]
    }
  );
};

// components/SlidersVertical.tsx
import { jsx as jsx14, jsxs as jsxs14 } from "react/jsx-runtime";
var SlidersVertical = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs14(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx14("title", { children: "SlidersVertical" }),
        /* @__PURE__ */ jsx14("line", { x1: "4", x2: "4", y1: "21", y2: "14" }),
        /* @__PURE__ */ jsx14("line", { x1: "4", x2: "4", y1: "10", y2: "3" }),
        /* @__PURE__ */ jsx14("line", { x1: "12", x2: "12", y1: "21", y2: "12" }),
        /* @__PURE__ */ jsx14("line", { x1: "12", x2: "12", y1: "8", y2: "3" }),
        /* @__PURE__ */ jsx14("line", { x1: "20", x2: "20", y1: "21", y2: "16" }),
        /* @__PURE__ */ jsx14("line", { x1: "20", x2: "20", y1: "12", y2: "3" }),
        /* @__PURE__ */ jsx14("line", { x1: "2", x2: "6", y1: "14", y2: "14" }),
        /* @__PURE__ */ jsx14("line", { x1: "10", x2: "14", y1: "8", y2: "8" }),
        /* @__PURE__ */ jsx14("line", { x1: "18", x2: "22", y1: "16", y2: "16" })
      ]
    }
  );
};

// components/Settings.tsx
import { jsx as jsx15, jsxs as jsxs15 } from "react/jsx-runtime";
var Settings = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs15(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx15("title", { children: "Settings" }),
        /* @__PURE__ */ jsx15("path", { d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" }),
        /* @__PURE__ */ jsx15("circle", { cx: "12", cy: "12", r: "3" })
      ]
    }
  );
};

// components/Search.tsx
import { jsx as jsx16, jsxs as jsxs16 } from "react/jsx-runtime";
var Search = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs16(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx16("title", { children: "Search" }),
        /* @__PURE__ */ jsx16("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ jsx16("path", { d: "m21 21-4.3-4.3" })
      ]
    }
  );
};

// components/Plus.tsx
import { jsx as jsx17, jsxs as jsxs17 } from "react/jsx-runtime";
var Plus = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs17(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx17("title", { children: "Plus" }),
        /* @__PURE__ */ jsx17("path", { d: "M5 12h14" }),
        /* @__PURE__ */ jsx17("path", { d: "M12 5v14" })
      ]
    }
  );
};

// components/Pencil.tsx
import { jsx as jsx18, jsxs as jsxs18 } from "react/jsx-runtime";
var Pencil = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs18(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx18("title", { children: "Pencil" }),
        /* @__PURE__ */ jsx18("path", { d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" }),
        /* @__PURE__ */ jsx18("path", { d: "m15 5 4 4" })
      ]
    }
  );
};

// components/PanelLeft.tsx
import { jsx as jsx19, jsxs as jsxs19 } from "react/jsx-runtime";
var PanelLeft = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs19(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx19("title", { children: "PanelLeft" }),
        /* @__PURE__ */ jsx19("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
        /* @__PURE__ */ jsx19("path", { d: "M9 3v18" })
      ]
    }
  );
};

// components/MoveRight.tsx
import { jsx as jsx20, jsxs as jsxs20 } from "react/jsx-runtime";
var MoveRight = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs20(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx20("title", { children: "MoveRight" }),
        /* @__PURE__ */ jsx20("path", { d: "M18 8L22 12L18 16" }),
        /* @__PURE__ */ jsx20("path", { d: "M2 12H22" })
      ]
    }
  );
};

// components/MoveDiagonal.tsx
import { jsx as jsx21, jsxs as jsxs21 } from "react/jsx-runtime";
var MoveDiagonal = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs21(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx21("title", { children: "MoveDiagonal" }),
        /* @__PURE__ */ jsx21("polyline", { points: "13 5 19 5 19 11" }),
        /* @__PURE__ */ jsx21("polyline", { points: "11 19 5 19 5 13" }),
        /* @__PURE__ */ jsx21("line", { x1: "19", x2: "5", y1: "5", y2: "19" })
      ]
    }
  );
};

// components/Moon.tsx
import { jsx as jsx22, jsxs as jsxs22 } from "react/jsx-runtime";
var Moon = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs22(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx22("title", { children: "Moon" }),
        /* @__PURE__ */ jsx22("path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" })
      ]
    }
  );
};

// components/MessageCircleMore.tsx
import { jsx as jsx23, jsxs as jsxs23 } from "react/jsx-runtime";
var MessageCircleMore = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs23(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx23("title", { children: "MessageCircleMore" }),
        /* @__PURE__ */ jsx23("path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z" }),
        /* @__PURE__ */ jsx23("path", { d: "M8 12h.01" }),
        /* @__PURE__ */ jsx23("path", { d: "M12 12h.01" }),
        /* @__PURE__ */ jsx23("path", { d: "M16 12h.01" })
      ]
    }
  );
};

// components/Menu.tsx
import { jsx as jsx24, jsxs as jsxs24 } from "react/jsx-runtime";
var Menu = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs24(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx24("title", { children: "Menu" }),
        /* @__PURE__ */ jsx24("line", { x1: "4", x2: "20", y1: "12", y2: "12" }),
        /* @__PURE__ */ jsx24("line", { x1: "4", x2: "20", y1: "6", y2: "6" }),
        /* @__PURE__ */ jsx24("line", { x1: "4", x2: "20", y1: "18", y2: "18" })
      ]
    }
  );
};

// components/Maximize2.tsx
import { jsx as jsx25, jsxs as jsxs25 } from "react/jsx-runtime";
var Maximize2 = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs25(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx25("title", { children: "Maximize2" }),
        /* @__PURE__ */ jsx25("polyline", { points: "15 3 21 3 21 9" }),
        /* @__PURE__ */ jsx25("polyline", { points: "9 21 3 21 3 15" }),
        /* @__PURE__ */ jsx25("line", { x1: "21", x2: "14", y1: "3", y2: "10" }),
        /* @__PURE__ */ jsx25("line", { x1: "3", x2: "10", y1: "21", y2: "14" })
      ]
    }
  );
};

// components/MapPin.tsx
import { jsx as jsx26, jsxs as jsxs26 } from "react/jsx-runtime";
var MapPin = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs26(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx26("title", { children: "MapPin" }),
        /* @__PURE__ */ jsx26("path", { d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" }),
        /* @__PURE__ */ jsx26("circle", { cx: "12", cy: "10", r: "3" })
      ]
    }
  );
};

// components/Mail.tsx
import { jsx as jsx27, jsxs as jsxs27 } from "react/jsx-runtime";
var Mail = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs27(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx27("title", { children: "Mail" }),
        /* @__PURE__ */ jsx27("rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }),
        /* @__PURE__ */ jsx27("path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" })
      ]
    }
  );
};

// components/LogOut.tsx
import { jsx as jsx28, jsxs as jsxs28 } from "react/jsx-runtime";
var LogOut = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs28(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx28("title", { children: "LogOut" }),
        /* @__PURE__ */ jsx28("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
        /* @__PURE__ */ jsx28("polyline", { points: "16 17 21 12 16 7" }),
        /* @__PURE__ */ jsx28("line", { x1: "21", x2: "9", y1: "12", y2: "12" })
      ]
    }
  );
};

// components/LoaderCircle.tsx
import { jsx as jsx29, jsxs as jsxs29 } from "react/jsx-runtime";
var LoaderCircle = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs29(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx29("title", { children: "LoaderCircle" }),
        /* @__PURE__ */ jsx29("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
      ]
    }
  );
};

// components/Linkedin.tsx
import { jsx as jsx30, jsxs as jsxs30 } from "react/jsx-runtime";
var Linkedin = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs30(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx30("title", { children: "Linkedin" }),
        /* @__PURE__ */ jsx30("path", { d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" }),
        /* @__PURE__ */ jsx30("rect", { width: "4", height: "12", x: "2", y: "9" }),
        /* @__PURE__ */ jsx30("circle", { cx: "4", cy: "4", r: "2" })
      ]
    }
  );
};

// components/Link.tsx
import { jsx as jsx31, jsxs as jsxs31 } from "react/jsx-runtime";
var Link = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs31(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx31("title", { children: "Link" }),
        /* @__PURE__ */ jsx31("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
        /* @__PURE__ */ jsx31("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
      ]
    }
  );
};

// components/Lightbulb.tsx
import { jsx as jsx32, jsxs as jsxs32 } from "react/jsx-runtime";
var Lightbulb = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs32(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx32("title", { children: "Lightbulb" }),
        /* @__PURE__ */ jsx32("path", { d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" }),
        /* @__PURE__ */ jsx32("path", { d: "M9 18h6" }),
        /* @__PURE__ */ jsx32("path", { d: "M10 22h4" })
      ]
    }
  );
};

// components/LayoutGrid.tsx
import { jsx as jsx33, jsxs as jsxs33 } from "react/jsx-runtime";
var LayoutGrid = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs33(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx33("title", { children: "LayoutGrid" }),
        /* @__PURE__ */ jsx33("rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }),
        /* @__PURE__ */ jsx33("rect", { width: "7", height: "7", x: "14", y: "3", rx: "1" }),
        /* @__PURE__ */ jsx33("rect", { width: "7", height: "7", x: "14", y: "14", rx: "1" }),
        /* @__PURE__ */ jsx33("rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" })
      ]
    }
  );
};

// components/Layers3.tsx
import { jsx as jsx34, jsxs as jsxs34 } from "react/jsx-runtime";
var Layers3 = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs34(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx34("title", { children: "Layers3" }),
        /* @__PURE__ */ jsx34("path", { d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" }),
        /* @__PURE__ */ jsx34("path", { d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59" }),
        /* @__PURE__ */ jsx34("path", { d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59" })
      ]
    }
  );
};

// components/Italic.tsx
import { jsx as jsx35, jsxs as jsxs35 } from "react/jsx-runtime";
var Italic = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs35(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx35("title", { children: "Italic" }),
        /* @__PURE__ */ jsx35("line", { x1: "19", x2: "10", y1: "4", y2: "4" }),
        /* @__PURE__ */ jsx35("line", { x1: "14", x2: "5", y1: "20", y2: "20" }),
        /* @__PURE__ */ jsx35("line", { x1: "15", x2: "9", y1: "4", y2: "20" })
      ]
    }
  );
};

// components/Info.tsx
import { jsx as jsx36, jsxs as jsxs36 } from "react/jsx-runtime";
var Info = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs36(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx36("title", { children: "Info" }),
        /* @__PURE__ */ jsx36("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx36("path", { d: "M12 16v-4" }),
        /* @__PURE__ */ jsx36("path", { d: "M12 8h.01" })
      ]
    }
  );
};

// components/Inbox.tsx
import { jsx as jsx37, jsxs as jsxs37 } from "react/jsx-runtime";
var Inbox = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs37(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx37("title", { children: "Inbox" }),
        /* @__PURE__ */ jsx37("polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12" }),
        /* @__PURE__ */ jsx37("path", { d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" })
      ]
    }
  );
};

// components/House.tsx
import { jsx as jsx38, jsxs as jsxs38 } from "react/jsx-runtime";
var House = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs38(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx38("title", { children: "House" }),
        /* @__PURE__ */ jsx38("path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" }),
        /* @__PURE__ */ jsx38("path", { d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" })
      ]
    }
  );
};

// components/Hourglass.tsx
import { jsx as jsx39, jsxs as jsxs39 } from "react/jsx-runtime";
var Hourglass = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs39(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx39("title", { children: "Hourglass" }),
        /* @__PURE__ */ jsx39("path", { d: "M5 22h14" }),
        /* @__PURE__ */ jsx39("path", { d: "M5 2h14" }),
        /* @__PURE__ */ jsx39("path", { d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" }),
        /* @__PURE__ */ jsx39("path", { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" })
      ]
    }
  );
};

// components/Heading.tsx
import { jsx as jsx40, jsxs as jsxs40 } from "react/jsx-runtime";
var Heading = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs40(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx40("title", { children: "Heading" }),
        /* @__PURE__ */ jsx40("path", { d: "M6 12h12" }),
        /* @__PURE__ */ jsx40("path", { d: "M6 20V4" }),
        /* @__PURE__ */ jsx40("path", { d: "M18 20V4" })
      ]
    }
  );
};

// components/Handshake.tsx
import { jsx as jsx41, jsxs as jsxs41 } from "react/jsx-runtime";
var Handshake = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs41(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx41("title", { children: "Handshake" }),
        /* @__PURE__ */ jsx41("path", { d: "m11 17 2 2a1 1 0 1 0 3-3" }),
        /* @__PURE__ */ jsx41("path", { d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" }),
        /* @__PURE__ */ jsx41("path", { d: "m21 3 1 11h-2" }),
        /* @__PURE__ */ jsx41("path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" }),
        /* @__PURE__ */ jsx41("path", { d: "M3 4h8" })
      ]
    }
  );
};

// components/Github.tsx
import { jsx as jsx42, jsxs as jsxs42 } from "react/jsx-runtime";
var Github = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs42(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx42("title", { children: "Github" }),
        /* @__PURE__ */ jsx42("path", { d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" }),
        /* @__PURE__ */ jsx42("path", { d: "M9 18c-4.51 2-5-2-7-2" })
      ]
    }
  );
};

// components/GitPullRequestArrow.tsx
import { jsx as jsx43, jsxs as jsxs43 } from "react/jsx-runtime";
var GitPullRequestArrow = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs43(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx43("title", { children: "GitPullRequestArrow" }),
        /* @__PURE__ */ jsx43("circle", { cx: "5", cy: "6", r: "3" }),
        /* @__PURE__ */ jsx43("path", { d: "M5 9v12" }),
        /* @__PURE__ */ jsx43("circle", { cx: "19", cy: "18", r: "3" }),
        /* @__PURE__ */ jsx43("path", { d: "m15 9-3-3 3-3" }),
        /* @__PURE__ */ jsx43("path", { d: "M12 6h5a2 2 0 0 1 2 2v7" })
      ]
    }
  );
};

// components/Filter.tsx
import { jsx as jsx44, jsxs as jsxs44 } from "react/jsx-runtime";
var Filter = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs44(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx44("title", { children: "Filter" }),
        /* @__PURE__ */ jsx44("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
      ]
    }
  );
};

// components/FileSearch.tsx
import { jsx as jsx45, jsxs as jsxs45 } from "react/jsx-runtime";
var FileSearch = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs45(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx45("title", { children: "FileSearch" }),
        /* @__PURE__ */ jsx45("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
        /* @__PURE__ */ jsx45("path", { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" }),
        /* @__PURE__ */ jsx45("path", { d: "m9 18-1.5-1.5" }),
        /* @__PURE__ */ jsx45("circle", { cx: "5", cy: "14", r: "3" })
      ]
    }
  );
};

// components/Eye.tsx
import { jsx as jsx46, jsxs as jsxs46 } from "react/jsx-runtime";
var Eye = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs46(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx46("title", { children: "Eye" }),
        /* @__PURE__ */ jsx46("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }),
        /* @__PURE__ */ jsx46("circle", { cx: "12", cy: "12", r: "3" })
      ]
    }
  );
};

// components/EyeOff.tsx
import { jsx as jsx47, jsxs as jsxs47 } from "react/jsx-runtime";
var EyeOff = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs47(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx47("title", { children: "EyeOff" }),
        /* @__PURE__ */ jsx47("path", { d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" }),
        /* @__PURE__ */ jsx47("path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242" }),
        /* @__PURE__ */ jsx47("path", { d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" }),
        /* @__PURE__ */ jsx47("path", { d: "m2 2 20 20" })
      ]
    }
  );
};

// components/Ellipsis.tsx
import { jsx as jsx48, jsxs as jsxs48 } from "react/jsx-runtime";
var Ellipsis = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs48(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx48("title", { children: "Ellipsis" }),
        /* @__PURE__ */ jsx48("circle", { cx: "12", cy: "12", r: "1" }),
        /* @__PURE__ */ jsx48("circle", { cx: "19", cy: "12", r: "1" }),
        /* @__PURE__ */ jsx48("circle", { cx: "5", cy: "12", r: "1" })
      ]
    }
  );
};

// components/EllipsisVertical.tsx
import { jsx as jsx49, jsxs as jsxs49 } from "react/jsx-runtime";
var EllipsisVertical = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs49(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx49("title", { children: "EllipsisVertical" }),
        /* @__PURE__ */ jsx49("circle", { cx: "12", cy: "12", r: "1" }),
        /* @__PURE__ */ jsx49("circle", { cx: "12", cy: "5", r: "1" }),
        /* @__PURE__ */ jsx49("circle", { cx: "12", cy: "19", r: "1" })
      ]
    }
  );
};

// components/Copy.tsx
import { jsx as jsx50, jsxs as jsxs50 } from "react/jsx-runtime";
var Copy = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs50(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx50("title", { children: "Copy" }),
        /* @__PURE__ */ jsx50("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }),
        /* @__PURE__ */ jsx50("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
      ]
    }
  );
};

// components/Clock.tsx
import { jsx as jsx51, jsxs as jsxs51 } from "react/jsx-runtime";
var Clock = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs51(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx51("title", { children: "Clock" }),
        /* @__PURE__ */ jsx51("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx51("polyline", { points: "12 6 12 12 16 14" })
      ]
    }
  );
};

// components/Clipboard.tsx
import { jsx as jsx52, jsxs as jsxs52 } from "react/jsx-runtime";
var Clipboard = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs52(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx52("title", { children: "Clipboard" }),
        /* @__PURE__ */ jsx52("rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }),
        /* @__PURE__ */ jsx52("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" })
      ]
    }
  );
};

// components/ClipboardCopy.tsx
import { jsx as jsx53, jsxs as jsxs53 } from "react/jsx-runtime";
var ClipboardCopy = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs53(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx53("title", { children: "ClipboardCopy" }),
        /* @__PURE__ */ jsx53("rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }),
        /* @__PURE__ */ jsx53("path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" }),
        /* @__PURE__ */ jsx53("path", { d: "M16 4h2a2 2 0 0 1 2 2v4" }),
        /* @__PURE__ */ jsx53("path", { d: "M21 14H11" }),
        /* @__PURE__ */ jsx53("path", { d: "m15 10-4 4 4 4" })
      ]
    }
  );
};

// components/Circle.tsx
import { jsx as jsx54, jsxs as jsxs54 } from "react/jsx-runtime";
var Circle = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs54(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx54("title", { children: "Circle" }),
        /* @__PURE__ */ jsx54("circle", { cx: "12", cy: "12", r: "10" })
      ]
    }
  );
};

// components/CircleX.tsx
import { jsx as jsx55, jsxs as jsxs55 } from "react/jsx-runtime";
var CircleX = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs55(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx55("title", { children: "CircleX" }),
        /* @__PURE__ */ jsx55("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx55("path", { d: "m15 9-6 6" }),
        /* @__PURE__ */ jsx55("path", { d: "m9 9 6 6" })
      ]
    }
  );
};

// components/CircleUser.tsx
import { jsx as jsx56, jsxs as jsxs56 } from "react/jsx-runtime";
var CircleUser = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs56(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx56("title", { children: "CircleUser" }),
        /* @__PURE__ */ jsx56("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx56("circle", { cx: "12", cy: "10", r: "3" }),
        /* @__PURE__ */ jsx56("path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" })
      ]
    }
  );
};

// components/CirclePlus.tsx
import { jsx as jsx57, jsxs as jsxs57 } from "react/jsx-runtime";
var CirclePlus = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs57(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx57("title", { children: "CirclePlus" }),
        /* @__PURE__ */ jsx57("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx57("path", { d: "M8 12h8" }),
        /* @__PURE__ */ jsx57("path", { d: "M12 8v8" })
      ]
    }
  );
};

// components/CircleHelp.tsx
import { jsx as jsx58, jsxs as jsxs58 } from "react/jsx-runtime";
var CircleHelp = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs58(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx58("title", { children: "CircleHelp" }),
        /* @__PURE__ */ jsx58("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx58("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }),
        /* @__PURE__ */ jsx58("path", { d: "M12 17h.01" })
      ]
    }
  );
};

// components/CircleDot.tsx
import { jsx as jsx59, jsxs as jsxs59 } from "react/jsx-runtime";
var CircleDot = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs59(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx59("title", { children: "CircleDot" }),
        /* @__PURE__ */ jsx59("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx59("circle", { cx: "12", cy: "12", r: "1" })
      ]
    }
  );
};

// components/CircleDashed.tsx
import { jsx as jsx60, jsxs as jsxs60 } from "react/jsx-runtime";
var CircleDashed = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs60(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx60("title", { children: "CircleDashed" }),
        /* @__PURE__ */ jsx60("path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0" }),
        /* @__PURE__ */ jsx60("path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0" }),
        /* @__PURE__ */ jsx60("path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7" }),
        /* @__PURE__ */ jsx60("path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8" }),
        /* @__PURE__ */ jsx60("path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69" }),
        /* @__PURE__ */ jsx60("path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8" }),
        /* @__PURE__ */ jsx60("path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69" }),
        /* @__PURE__ */ jsx60("path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7" })
      ]
    }
  );
};

// components/CircleCheck.tsx
import { jsx as jsx61, jsxs as jsxs61 } from "react/jsx-runtime";
var CircleCheck = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs61(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx61("title", { children: "CircleCheck" }),
        /* @__PURE__ */ jsx61("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx61("path", { d: "m9 12 2 2 4-4" })
      ]
    }
  );
};

// components/CircleAlert.tsx
import { jsx as jsx62, jsxs as jsxs62 } from "react/jsx-runtime";
var CircleAlert = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs62(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx62("title", { children: "CircleAlert" }),
        /* @__PURE__ */ jsx62("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx62("line", { x1: "12", x2: "12", y1: "8", y2: "12" }),
        /* @__PURE__ */ jsx62("line", { x1: "12", x2: "12.01", y1: "16", y2: "16" })
      ]
    }
  );
};

// components/ChevronsUpDown.tsx
import { jsx as jsx63, jsxs as jsxs63 } from "react/jsx-runtime";
var ChevronsUpDown = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs63(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx63("title", { children: "ChevronsUpDown" }),
        /* @__PURE__ */ jsx63("path", { d: "m7 15 5 5 5-5" }),
        /* @__PURE__ */ jsx63("path", { d: "m7 9 5-5 5 5" })
      ]
    }
  );
};

// components/ChevronUp.tsx
import { jsx as jsx64, jsxs as jsxs64 } from "react/jsx-runtime";
var ChevronUp = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs64(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx64("title", { children: "ChevronUp" }),
        /* @__PURE__ */ jsx64("path", { d: "m18 15-6-6-6 6" })
      ]
    }
  );
};

// components/ChevronRight.tsx
import { jsx as jsx65, jsxs as jsxs65 } from "react/jsx-runtime";
var ChevronRight = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs65(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx65("title", { children: "ChevronRight" }),
        /* @__PURE__ */ jsx65("path", { d: "m9 18 6-6-6-6" })
      ]
    }
  );
};

// components/ChevronLeft.tsx
import { jsx as jsx66, jsxs as jsxs66 } from "react/jsx-runtime";
var ChevronLeft = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs66(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx66("title", { children: "ChevronLeft" }),
        /* @__PURE__ */ jsx66("path", { d: "m15 18-6-6 6-6" })
      ]
    }
  );
};

// components/ChevronDown.tsx
import { jsx as jsx67, jsxs as jsxs67 } from "react/jsx-runtime";
var ChevronDown = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs67(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx67("title", { children: "ChevronDown" }),
        /* @__PURE__ */ jsx67("path", { d: "m6 9 6 6 6-6" })
      ]
    }
  );
};

// components/Check.tsx
import { jsx as jsx68, jsxs as jsxs68 } from "react/jsx-runtime";
var Check = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs68(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx68("title", { children: "Check" }),
        /* @__PURE__ */ jsx68("path", { d: "M20 6 9 17l-5-5" })
      ]
    }
  );
};

// components/Calendar.tsx
import { jsx as jsx69, jsxs as jsxs69 } from "react/jsx-runtime";
var Calendar = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs69(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx69("title", { children: "Calendar" }),
        /* @__PURE__ */ jsx69("path", { d: "M8 2v4" }),
        /* @__PURE__ */ jsx69("path", { d: "M16 2v4" }),
        /* @__PURE__ */ jsx69("rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }),
        /* @__PURE__ */ jsx69("path", { d: "M3 10h18" })
      ]
    }
  );
};

// components/BriefcaseBusiness.tsx
import { jsx as jsx70, jsxs as jsxs70 } from "react/jsx-runtime";
var BriefcaseBusiness = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs70(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx70("title", { children: "BriefcaseBusiness" }),
        /* @__PURE__ */ jsx70("path", { d: "M12 12h.01" }),
        /* @__PURE__ */ jsx70("path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }),
        /* @__PURE__ */ jsx70("path", { d: "M22 13a18.15 18.15 0 0 1-20 0" }),
        /* @__PURE__ */ jsx70("rect", { width: "20", height: "14", x: "2", y: "6", rx: "2" })
      ]
    }
  );
};

// components/Box.tsx
import { jsx as jsx71, jsxs as jsxs71 } from "react/jsx-runtime";
var Box = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs71(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx71("title", { children: "Box" }),
        /* @__PURE__ */ jsx71("path", { d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" }),
        /* @__PURE__ */ jsx71("path", { d: "m3.3 7 8.7 5 8.7-5" }),
        /* @__PURE__ */ jsx71("path", { d: "M12 22V12" })
      ]
    }
  );
};

// components/Bookmark.tsx
import { jsx as jsx72, jsxs as jsxs72 } from "react/jsx-runtime";
var Bookmark = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs72(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx72("title", { children: "Bookmark" }),
        /* @__PURE__ */ jsx72("path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" })
      ]
    }
  );
};

// components/BookmarkMinus.tsx
import { jsx as jsx73, jsxs as jsxs73 } from "react/jsx-runtime";
var BookmarkMinus = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs73(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx73("title", { children: "BookmarkMinus" }),
        /* @__PURE__ */ jsx73("path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" }),
        /* @__PURE__ */ jsx73("line", { x1: "15", x2: "9", y1: "10", y2: "10" })
      ]
    }
  );
};

// components/Bold.tsx
import { jsx as jsx74, jsxs as jsxs74 } from "react/jsx-runtime";
var Bold = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs74(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx74("title", { children: "Bold" }),
        /* @__PURE__ */ jsx74("path", { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8" })
      ]
    }
  );
};

// components/BellOff.tsx
import { jsx as jsx75, jsxs as jsxs75 } from "react/jsx-runtime";
var BellOff = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs75(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx75("title", { children: "BellOff" }),
        /* @__PURE__ */ jsx75("path", { d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5" }),
        /* @__PURE__ */ jsx75("path", { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7" }),
        /* @__PURE__ */ jsx75("path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0" }),
        /* @__PURE__ */ jsx75("path", { d: "m2 2 20 20" })
      ]
    }
  );
};

// components/BadgePlus.tsx
import { jsx as jsx76, jsxs as jsxs76 } from "react/jsx-runtime";
var BadgePlus = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs76(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx76("title", { children: "BadgePlus" }),
        /* @__PURE__ */ jsx76("path", { d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" }),
        /* @__PURE__ */ jsx76("line", { x1: "12", x2: "12", y1: "8", y2: "16" }),
        /* @__PURE__ */ jsx76("line", { x1: "8", x2: "16", y1: "12", y2: "12" })
      ]
    }
  );
};

// components/ArrowUp.tsx
import { jsx as jsx77, jsxs as jsxs77 } from "react/jsx-runtime";
var ArrowUp = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs77(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx77("title", { children: "ArrowUp" }),
        /* @__PURE__ */ jsx77("path", { d: "m5 12 7-7 7 7" }),
        /* @__PURE__ */ jsx77("path", { d: "M12 19V5" })
      ]
    }
  );
};

// components/ArrowUpWideNarrow.tsx
import { jsx as jsx78, jsxs as jsxs78 } from "react/jsx-runtime";
var ArrowUpWideNarrow = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs78(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx78("title", { children: "ArrowUpWideNarrow" }),
        /* @__PURE__ */ jsx78("path", { d: "m3 8 4-4 4 4" }),
        /* @__PURE__ */ jsx78("path", { d: "M7 4v16" }),
        /* @__PURE__ */ jsx78("path", { d: "M11 12h10" }),
        /* @__PURE__ */ jsx78("path", { d: "M11 16h7" }),
        /* @__PURE__ */ jsx78("path", { d: "M11 20h4" })
      ]
    }
  );
};

// components/ArrowRight.tsx
import { jsx as jsx79, jsxs as jsxs79 } from "react/jsx-runtime";
var ArrowRight = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs79(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx79("title", { children: "ArrowRight" }),
        /* @__PURE__ */ jsx79("path", { d: "M5 12h14" }),
        /* @__PURE__ */ jsx79("path", { d: "m12 5 7 7-7 7" })
      ]
    }
  );
};

// components/ArrowLeft.tsx
import { jsx as jsx80, jsxs as jsxs80 } from "react/jsx-runtime";
var ArrowLeft = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs80(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx80("title", { children: "ArrowLeft" }),
        /* @__PURE__ */ jsx80("path", { d: "m12 19-7-7 7-7" }),
        /* @__PURE__ */ jsx80("path", { d: "M19 12H5" })
      ]
    }
  );
};

// components/ArrowLeftRight.tsx
import { jsx as jsx81, jsxs as jsxs81 } from "react/jsx-runtime";
var ArrowLeftRight = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs81(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx81("title", { children: "ArrowLeftRight" }),
        /* @__PURE__ */ jsx81("path", { d: "M8 3 4 7l4 4" }),
        /* @__PURE__ */ jsx81("path", { d: "M4 7h16" }),
        /* @__PURE__ */ jsx81("path", { d: "m16 21 4-4-4-4" }),
        /* @__PURE__ */ jsx81("path", { d: "M20 17H4" })
      ]
    }
  );
};

// components/ArrowDown.tsx
import { jsx as jsx82, jsxs as jsxs82 } from "react/jsx-runtime";
var ArrowDown = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs82(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx82("title", { children: "ArrowDown" }),
        /* @__PURE__ */ jsx82("path", { d: "M12 5v14" }),
        /* @__PURE__ */ jsx82("path", { d: "m19 12-7 7-7-7" })
      ]
    }
  );
};

// components/ArrowDownWideNarrow.tsx
import { jsx as jsx83, jsxs as jsxs83 } from "react/jsx-runtime";
var ArrowDownWideNarrow = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs83(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx83("title", { children: "ArrowDownWideNarrow" }),
        /* @__PURE__ */ jsx83("path", { d: "m3 16 4 4 4-4" }),
        /* @__PURE__ */ jsx83("path", { d: "M7 20V4" }),
        /* @__PURE__ */ jsx83("path", { d: "M11 4h10" }),
        /* @__PURE__ */ jsx83("path", { d: "M11 8h7" }),
        /* @__PURE__ */ jsx83("path", { d: "M11 12h4" })
      ]
    }
  );
};

// components/Archive.tsx
import { jsx as jsx84, jsxs as jsxs84 } from "react/jsx-runtime";
var Archive = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs84(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx84("title", { children: "Archive" }),
        /* @__PURE__ */ jsx84("rect", { width: "20", height: "5", x: "2", y: "3", rx: "1" }),
        /* @__PURE__ */ jsx84("path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }),
        /* @__PURE__ */ jsx84("path", { d: "M10 12h4" })
      ]
    }
  );
};

// components/Activity.tsx
import { jsx as jsx85, jsxs as jsxs85 } from "react/jsx-runtime";
var Activity = ({
  className = "",
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  absoluteStrokeWidth = false
}) => {
  const scale = size / 24;
  const scaledStrokeWidth = absoluteStrokeWidth ? strokeWidth : strokeWidth / scale;
  return /* @__PURE__ */ jsxs85(
    "svg",
    {
      className,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: scaledStrokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx85("title", { children: "Activity" }),
        /* @__PURE__ */ jsx85("path", { d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" })
      ]
    }
  );
};
export {
  Activity,
  Archive,
  ArrowDown,
  ArrowDownWideNarrow,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpWideNarrow,
  BadgePlus,
  BellOff,
  Bold,
  Bookmark,
  BookmarkMinus,
  Box,
  BriefcaseBusiness,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleDot,
  CircleHelp,
  CirclePlus,
  CircleUser,
  CircleX,
  Clipboard,
  ClipboardCopy,
  Clock,
  Copy,
  Ellipsis,
  EllipsisVertical,
  Eye,
  EyeOff,
  FileSearch,
  Filter,
  GitPullRequestArrow,
  Github,
  Handshake,
  Heading,
  Hourglass,
  House,
  Inbox,
  Info,
  Italic,
  Layers3,
  LayoutGrid,
  Lightbulb,
  Link,
  Linkedin,
  LoaderCircle,
  LogOut,
  Mail,
  MapPin,
  Maximize2,
  Menu,
  MessageCircleMore,
  Moon,
  MoveDiagonal,
  MoveRight,
  PanelLeft,
  Pencil,
  Plus,
  Search,
  Settings,
  SlidersVertical,
  SquarePen,
  Sun,
  Tag,
  ThumbsUp,
  Trash,
  Trash2,
  TriangleAlert,
  User,
  UserCog,
  UserRoundPlus,
  UserSearch,
  Users,
  X
};
//# sourceMappingURL=index.mjs.map
